<template>
    <section id="sub-heading-holder"
             class="content-sub-header">
        <ul class="heading-tabs">
            <li id="tab-0"
                :class="liClass(0)">
                <a @click="tabChosen(0)">
                    User Guide
                </a>
            </li>
            <li id="tab-1"
                :class="liClass(1)">
                <a @click="tabChosen(1)">
                    Contact us
                </a>
            </li>
            <li id="tab-2"
                :class="liClass(2)">
                <a @click="tabChosen(2)">
                    New features
                </a>
            </li>
        </ul>
    </section>

    <section id="content">
        <div v-show="displayed == 0">
            <user-guide :displayed="displayed"
                        :intial-help-file="intialHelpFile" />
        </div>
        <div v-show="displayed == 1">
            <contact-us />
        </div>
        <div v-show="displayed == 2">
            <release-notes />
        </div>
    </section>
</template>

<script setup>
    import { ref, onMounted } from 'vue';
    import { setNumberFromElementVal, setFromElementVal } from '../../js/ElementReading.js';
    import userGuide from '../../components/help/UserGuide.vue';
    import releaseNotes from '../../components/help/ReleaseNotes.vue';
    import contactUs from '../../components/help/ContactUs.vue';

    const displayed = ref(0);
    const intialHelpFile = ref('');

    onMounted(() => {
        setNumberFromElementVal(displayed, "displayed");
        setFromElementVal(intialHelpFile, "initialHelpFile");
    });

    function tabChosen(val) {
        displayed.value = val;
        window.history.replaceState(null, null, `/GetHelp?displayed=${displayed.value}`);
    }

    function liClass(num) {
        let cl = "report-tab heading-tab";
        if (num === displayed.value) {
            cl += " actives";
        }
        return cl;
    }
</script>
